export default function Solution() {
  const steps = [
    { number: '01', title: '目標設定', description: 'あなたの状況に合わせた最適な目標を設定' },
    { number: '02', title: 'ルート設計', description: 'PP単価を最適化した効率的なルート' },
    { number: '03', title: '実行管理', description: '制度変更にも柔軟に対応しながら進行' }
  ];

  const features = [
    '感覚ではなく、数字で逆算する。',
    '制度変更を織り込んだ、柔軟な設計。',
    'PP単価・総コスト・時間効率を最適化。'
  ];

  return (
    <section className="py-28 px-6 bg-[#F5F5F3]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
        {/* Left Text */}
        <div className="lg:col-span-2">
          <div className="text-sm font-semibold text-[#0D47A1] tracking-widest mb-5">SOLUTION</div>
          <h2 className="text-4xl font-bold text-[#1A2B4A] leading-snug mb-8">
            "設計型修行"という<br />
            合理的アプローチ
          </h2>
          
          <div className="space-y-5">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-[#0D47A1] mt-2 flex-shrink-0"></div>
                <p className="text-base leading-relaxed text-[#5A5A5A]">{feature}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right Flow Chart */}
        <div className="lg:col-span-3">
          <div className="space-y-6">
            {steps.map((step, index) => (
              <div key={index}>
                <div className="bg-white rounded-xl shadow-sm p-8 flex items-center gap-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-[#E8EAF6] rounded-full flex-shrink-0">
                    <span className="text-2xl font-bold text-[#0D47A1]">{step.number}</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-[#1A2B4A] mb-2">{step.title}</h3>
                    <p className="text-[15px] text-[#5A5A5A]">{step.description}</p>
                  </div>
                </div>
                {index < steps.length - 1 && (
                  <div className="flex justify-center py-3">
                    <i className="ri-arrow-down-line text-3xl text-[#0D47A1]"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
